import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgClass } from '@angular/common';
import {
    Component,
    Inject,
    ViewEncapsulation,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { HippoConfirmationConfig } from '@hippo/services/confirmation/confirmation.types';

@Component({
    selector: 'hippo-confirmation-dialog',
    templateUrl: './dialog.component.html',
    styles: [
        `
            .hippo-confirmation-dialog-panel {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {
                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
            .hippo-confirmation__title {
                background-color: #001432;
                color: #ffffff;
                font-size: 1.25rem;
                font-weight: 500;
                line-height: 1.5rem;
                padding: 1rem;
            }
            .hippo-confirmation-dialog--soft {
                .hippo-confirmation__title {
                    background-color: var(--hippo-line);
                    border-bottom: 1px solid var(--hippo-navy);
                    color: var(--hippo-navy);
                    font-size: 17px;
                    font-weight: 600;
                    line-height: 24px;
                    padding: 16px 64px 16px 24px;
                }

                .hippo-confirmation__close {
                    --mat-icon-button-icon-color: var(--hippo-navy);
                    margin-top: -8px;

                    .mat-icon {
                        color: var(--hippo-navy) !important;
                    }
                }

                .hippo-confirmation__title--icon {
                    padding-bottom: 12px;
                    padding-top: 12px;
                }

                .hippo-confirmation__body--aligned {
                    padding-left: 68px;
                }
            }
            .hippo-confirmation__title--icon {
                align-items: center;
                display: flex;
                gap: 12px;
            }
            .hippo-confirmation__title-icon {
                align-items: center;
                border-radius: 999px;
                display: inline-flex;
                flex: 0 0 auto;
                height: 32px;
                justify-content: center;
                width: 32px;
            }
            .hippo-confirmation__body--aligned {
                padding: 20px 32px 24px 60px;
            }
            .hippo-confirmation-card {
                background-color: var(--hippo-tint-100);
                color: var(--hippo-navy);
                display: flex;
                flex-direction: column;
                max-height: calc(100vh - 32px);
            }
            .hippo-confirmation-card__head {
                align-items: center;
                border-bottom: 1px solid rgb(140 170 205 / 30%);
                cursor: move;
                display: flex;
                flex: 0 0 auto;
                gap: 14px;
                min-height: 75px;
                padding: 18px 20px 16px;
            }
            .hippo-confirmation-card__icon {
                align-items: center;
                display: inline-flex;
                flex: 0 0 auto;
                height: 40px;
                justify-content: center;
                width: 40px;

                &.is-success {
                    color: #15803d;
                }

                &.is-warning {
                    color: #b45309;
                }

                &.is-warn,
                &.is-error {
                    color: #c62828;
                }
            }
            .hippo-confirmation-card__title {
                flex: 1 1 auto;
                font-size: 17px;
                font-weight: 600;
                line-height: 24px;
                margin: 0;
                min-width: 0;
                overflow-wrap: break-word;
            }
            .hippo-confirmation-card__close {
                align-items: center;
                border-radius: 8px;
                display: inline-flex;
                flex: 0 0 auto;
                height: 32px;
                justify-content: center;
                margin-right: -6px;
                transition: background-color 0.15s ease;
                width: 32px;

                &:hover {
                    background-color: rgb(140 170 205 / 25%);
                }

                &:focus-visible {
                    box-shadow: 0 0 0 3px rgb(140 170 205 / 45%);
                    outline: none;
                }
            }
            .hippo-confirmation-card__body {
                flex: 1 1 auto;
                min-height: 0;
                overflow: auto;
                padding: 16px 20px 4px;
            }
            .hippo-confirmation-card__message {
                background-color: #ffffff;
                border: 1px solid rgb(140 170 205 / 35%);
                border-radius: 10px;
                font-size: 14px;
                line-height: 20px;
                overflow-wrap: break-word;
                padding: 12px 14px;
            }
            .hippo-confirmation-card__actions {
                display: grid;
                flex: 0 0 auto;
                gap: 10px;
                grid-auto-columns: minmax(0, 1fr);
                grid-auto-flow: column;
                padding: 12px 20px 20px;
            }
            .hippo-confirmation-card__btn {
                background-color: var(--hippo-navy);
                border: 1px solid var(--hippo-navy);
                border-radius: 8px;
                color: #ffffff;
                font-size: 14px;
                font-weight: 500;
                line-height: 20px;
                min-height: 40px;
                padding: 9px 16px;
                transition:
                    background-color 0.15s ease,
                    border-color 0.15s ease;

                &:hover {
                    background-color: var(--hippo-navy-soft);
                    border-color: var(--hippo-navy-soft);
                }

                &:focus-visible {
                    box-shadow: 0 0 0 3px rgb(140 170 205 / 45%);
                    outline: none;
                }

                &.is-danger {
                    background-color: #c62828;
                    border-color: #c62828;

                    &:hover {
                        background-color: #a81f1f;
                        border-color: #a81f1f;
                    }
                }
            }
            .hippo-confirmation-dialog-panel-small {
                @screen md {
                    @apply w-128;
                }

                .mat-mdc-dialog-container {
                    zoom: 50% !important;
                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
            .hippo-confirmation-dialog--card {
                width: 400px;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        NgClass,
        CdkDrag,
        CdkDragHandle,
    ],
})
export class HippoConfirmationDialogComponent {
    private readonly iconColors: Record<string, string> = {
        primary:
            'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600',
        accent: 'text-accent-600 bg-accent-100 dark:text-accent-50 dark:bg-accent-600',
        warn: 'text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600',
        basic: 'text-gray-600 bg-gray-100 dark:text-gray-50 dark:bg-gray-600',
        info: 'text-blue-600 bg-blue-100 dark:text-blue-50 dark:bg-blue-600',
        success:
            'text-green-500 bg-green-100 dark:text-green-50 dark:bg-green-500',
        warning:
            'text-amber-500 bg-amber-100 dark:text-amber-50 dark:bg-amber-500',
        error: 'text-red-600 bg-red-100 dark:text-red-50 dark:bg-red-600',
    };

    /**
     * Constructor
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: HippoConfirmationConfig
    ) {}

    get iconColor(): string {
        return this.iconColors[this.data.icon?.color ?? ''] ?? '';
    }

    get iconInTitle(): boolean {
        return (
            !!this.data.title &&
            !!this.data.icon?.show &&
            !!this.data.icon?.inTitle
        );
    }
}
